const EDDAction = {
  SET: {
    PINCODE_MODAL: 'EDDAction.Set.PincodeModal',
    MOVE_TO_CLOSET: 'EDDAction.Set.MoveToCloset',
    SELECTED_SLA_OPTION: 'EDDAction.Set.SelectedSlaOption'
  },
  RESET: {
    DELIVERY_DETAILS: 'EDDAction.Reset.DeleveryDetails'
  },
  REMOVE: {
    NON_VELIVERABLE_ITEM: 'EDDAction.Remove.NonDeleverableItem'
  },
  FETCH: {
    DELIVERY_DETAILS: {
      REQUEST: 'EDDAction.Fetch.DeleveryDetails.Request',
      SUCCESS: 'EDDAction.Fetch.DeleveryDetails.Success',
      FAILURE: 'EDDAction.Fetch.DeleveryDetails.Failure'
    },
    DELIVERY_DETAILS_V2: {
      REQUEST: 'EDDAction.Fetch.DeleveryDetailsV2.Request',
      SUCCESS: 'EDDAction.Fetch.DeleveryDetailsV2.Success',
      FAILURE: 'EDDAction.Fetch.DeleveryDetailsV2.Failure'
    },
    PRODUCT_SERVICEABILITY_DETAILS:{
      REQUEST: 'EDDAction.Fetch.ProductServiceabilityDetails.Request',
      SUCCESS: 'EDDAction.Fetch.ProductServiceabilityDetails.Success',
      FAILURE: 'EDDAction.Fetch.ProductServiceabilityDetails.Failure'
    },
    CART_ITEMS_DELIVERY_DETAILS: {
      REQUEST: 'EDDAction.Fetch.CartItemDeliveryDetails.Request',
      SUCCESS: 'EDDAction.Fetch.CartItemDeliveryDetails.Success',
      FAILURE: 'EDDAction.Fetch.CartItemDeliveryDetails.Failure'
    }
  },
  MOVE: {
    ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET: {
      REQUEST: 'EDDAction.Move.AllNonDeliverableItemsToCloset.Request',
      FAILURE: 'EDDAction.Move.AllNonDeliverableItemsToCloset.Failure',
      SUCCESS: 'EDDAction.Move.AllNonDeliverableItemsToCloset.Success'
    }
  }
};

export default EDDAction;
